export const MODAL_NAME = 'orders.cancel-pickup'
